<script>
import bem from '@/utils/bem';

const b = bem('variable-popup');
export default {
  data() {
    return {
      popupTextValue: '',
      popupTextLink: '',
      popupSelectorValue: null,
    };
  },
  props: {
    closeVariable: {
      type: Function,
      required: false,
      default: () => {},
    },
    saveVariable: {
      type: Function,
      required: false,
      default: () => {},
    },
    textPopup: {
      type: String,
      required: false,
      default: '',
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
    links: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    constants: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    clickClose() {
      this.popupSelectorValue = null;
      this.popupTextValue = '';
      this.popupTextLink = '';
      this.closeVariable();
    },
    clickSave() {
      this.saveVariable(
        this.popupTextValue,
        this.textPopup === 'customLink'
          ? this.popupTextLink
          : this.popupSelectorValue,
      );
      this.popupSelectorValue = null;
      this.popupTextValue = '';
      this.popupTextLink = '';
    },
    checkDisable() {
      switch (this.textPopup) {
        case 'link': {
          return !this.popupSelectorValue || !this.popupTextValue;
        }
        case 'customLink': {
          return !this.popupTextValue || !this.popupTextLink;
        }
        case 'variable': {
          return !this.popupSelectorValue;
        }
        default: {
          return true;
        }
      }
    },
  },
};
</script>

<template>
  <div :class="b('', { mix: className })">
    <div :class="b('add-variable-block')">
      <div :class="b('style-item')" v-if="['link', 'customLink'].includes(textPopup)">
        <div :class="b('title')">Link text</div>
        <a-input
          v-model:value="popupTextValue"
          style="max-width: 350px"
        />
      </div>
      <div :class="b('style-item')">
        <div class="b('title')">
          {{['link', 'customLink'].includes(textPopup) ? 'Link' : 'Variable'}}
        </div>
        <a-input
          v-if="textPopup === 'customLink'"
          v-model:value="popupTextLink"
          style="max-width: 350px"
        />
        <a-select
          v-else
          style="width: 100%"
          :options="textPopup === 'link' ? links : constants"
          v-model:value="popupSelectorValue"
        />
      </div>
      <div :class="b('add-variable-buttons')">
        <a-button
          html-type="button"
          @click="clickClose()"
        >
          Cancel
        </a-button>
        <a-button
          type="primary"
          html-type="button"
          @click="clickSave()"
          :disabled="checkDisable()"
        >
          Save
        </a-button>
      </div>
    </div>
  </div>
</template>

<style src="./variablePopupStyle.scss" scoped lang="scss"></style>
